export default __webpack_public_path__ + "static/media/grape_icon.47138093.svg";